/* Константа со списком пунктов меню
   и ссылок на их страницы */

export const listNav = [
  {
    title: 'Главное',
    link: '/',
  },
  {
    title: 'Аналитика',
    link: '/analytics',
  },
  {
    title: 'Программы',
    link: '/programs',
  },
  {
    title: 'Аудиокниги',
    link: '/audiobooks',
  },
  {
    title: 'Расписание',
    link: '/program-guide',
  },
  {
    title: 'Награды',
    link: '/awards',
  },
] as const;
